import { emptyList, ItemList } from '../../../common/models/ItemList'
import { Observable, of } from 'rxjs'
import { Container, IInit } from '../../../common/container/Container'
import { HTTP_CLIENT_KEY, IHTTPClient } from '../../../common/api/HTTPClient'
import { IStatusService } from '../../../common/status/StatusService'
import { STATUS_SERVICE_KEY } from '../../../container/app'
import { Query } from '../../../common/api/Query'
import { Faq, FaqQuery } from '../models/Faq'
import { FaqContainerConfig } from '../container'
import { FaqDTO, toModel } from '../models/FaqDTO'
import { prepareURL } from '../../../common/api/http-helpers'
import { catchError, map } from 'rxjs/operators'

export interface IFaqApi extends IInit {
  getByID(id: string): Observable<Faq | undefined>

  getFilteredList(q: Query<FaqQuery>): Observable<ItemList<Faq>>

  add(e: FaqDTO): Observable<Faq | undefined>

  update(e: FaqDTO): Observable<Faq | undefined>

  delete(id: string): Observable<boolean>
}

export class FaqApi implements IFaqApi {
  private _container!: Container
  private _httpClient!: IHTTPClient
  private _url!: string
  private _statusService!: IStatusService

  init(c: Container) {
    this._container = c
    this._httpClient = this._container.get<IHTTPClient>(HTTP_CLIENT_KEY)
    this._statusService = this._container.get<IStatusService>(STATUS_SERVICE_KEY)
    this._url = (this._container.config as FaqContainerConfig).moduleFullUrl
  }

  add(e: FaqDTO): Observable<Faq | undefined> {
    return this._httpClient.post<Faq>({ url: this._url, body: e }).pipe(
      map<FaqDTO, Faq>((d) => toModel(d)),
      catchError((err) => {
        this._statusService.sendStatus({ variant: 'error', error: err })
        return of(undefined)
      })
    )
  }

  delete(id: string): Observable<boolean> {
    return this._httpClient.delete({ url: this._url + '/' + id }).pipe(
      catchError((err) => {
        this._statusService.sendStatus({ variant: 'error', error: err })
        return of(false)
      })
    )
  }

  getByID(id: string): Observable<Faq | undefined> {
    return this._httpClient.get<Faq>({ url: `${this._url}/${id}` }).pipe(
      map<FaqDTO, Faq>((d) => toModel(d)),
      catchError((err) => {
        this._statusService.sendStatus({ variant: 'error', error: err })
        return of(undefined)
      })
    )
  }

  getFilteredList(q: Query<FaqQuery>): Observable<ItemList<Faq>> {
    return this._httpClient.get<ItemList<Faq>>({ url: prepareURL(this._url, q) }).pipe(
      map<ItemList<FaqDTO>, ItemList<Faq>>((dto) => {
        const itemList = emptyList<Faq>()
        itemList.count = dto.count
        itemList.items = dto.items.map((d) => toModel(d))
        return itemList
      }),
      catchError((err) => {
        this._statusService.sendStatus({ variant: 'error', error: err })
        return of(emptyList<Faq>())
      })
    )
  }

  update(e: FaqDTO): Observable<Faq | undefined> {
    return this._httpClient.put<Faq>({ url: this._url, body: e }).pipe(
      map<FaqDTO, Faq>((d) => toModel(d)),
      catchError((err) => {
        this._statusService.sendStatus({ variant: 'error', error: err })
        return of(undefined)
      })
    )
  }
}
